/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import AlertModel from "@/models/AlertModel";
import moment from "moment";
export default {
  formatDate(value: string | null) {
    return moment(String(value)).format("DD-MM-YYYY");
  },
  tanggalBerlalu(value: string | null) {
    return moment(String(value), "YYYYMMDD").fromNow();
    // return moment().startOf("hour").fromNow();
  },
  unFormatDate(value: string | null) {
    return moment(String(value)).format("YYYY-MM-DD");
  },
  unFormatDateNow(value) {
    return moment(value).format("YYYY-MM-DD");
  },
  formatTime(value: string | null) {
    return moment(String(value)).format("HH:MM");
  },
  getFormattedTime(value: string | null) {
    let formatted: string | null = null;
    if (value && value !== "null" && value !== "") {
      const [hours, minutes] = value.split(":");
      formatted = `${hours}:${minutes}`;
    }
    return formatted;
  },
  getDateFromTimestamp(value: string | null) {
    let formatted: string | null = null;
    if (value && value !== "null" && value !== "") {
      const [date] = value.split("T");
      const [year, month, day] = date.split("-");
      formatted = `${year}-${month}-${day}`;
    }
    return formatted;
  },
  getTimeFromTimestamp(value: string | null) {
    let formatted: string | null = null;
    if (value && value !== "null" && value !== "") {
      const time = value.substring(11, 16);
      formatted = `${time}`;
    }
    return formatted;
  },
  getFormattedDate(value: string | null) {
    let formatted: string | null = null;
    if (value && value !== "null" && value !== "") {
      const [year, month, day] = value.split("-");
      formatted = `${day}-${month}-${year}`;
    }
    return formatted;
  },
  getUnformattedDate(value: string | null) {
    let unformatted: string | null = null;
    if (value && value !== "null" && value !== "") {
      const [day, month, year] = value.split("-");
      unformatted = `${year}-${month}-${day}`;
    }
    return unformatted;
  },
  dateToIndonesianLongDate(value: string | null): string | null {
    let unformatted: string | null = null;
    if (value && value !== "null" && value !== "") {
      const listBulan = [
        "",
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];
      const [year, month, day] = value.split("-");
      unformatted = `${Number(day)} ${
        listBulan[Math.abs(Number(month))]
      } ${year}`;
    }
    return unformatted;
  },
  dateToIndonesianLongDateDay(value: string | null): string | null {
    let unformatted: string | null = null;
    if (value && value !== "null" && value !== "") {
      const d = new Date(value);
      const hari = d.getDay();
      const listHari = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu",
      ];
      const dayName = listHari[hari];
      const listBulan = [
        "",
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];
      const [year, month, day] = value.split("-");
      unformatted = `${dayName}, ${Number(day)} ${
        listBulan[Math.abs(Number(month))]
      } ${year}`;
    }
    return unformatted;
  },
  getFormattedDateIndoMonth(value: string | null) {
    let formatted: string | null = null;
    if (value && value !== "null" && value !== "") {
      const listBulan = [
        "",
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MEI",
        "JUN",
        "JUL",
        "AGU",
        "SEP",
        "OKT",
        "NOV",
        "DES",
      ];
      const [year, month, day] = value.split("-");
      formatted = `${day}/${listBulan[Math.abs(Number(month))]}/${year}`;
    }
    return formatted;
  },
  getAlertFromResponse(
    responseCode: number,
    responseDesc: string,
    responseData: string
  ) {
    const alert = new AlertModel();
    alert.alertState = true;
    if (responseCode === 200) {
      alert.alertType = "success";
      alert.alertMessage = `${responseDesc}`;
    } else {
      alert.alertType = "error";
      alert.alertMessage = `${responseDesc} - ${responseData || ""}`;
    }
    return alert;
  },
  stripHtmlTags(html: string | null) {
    if (!html) return "";
    // Create a temporary div element to parse HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  },
};
